<script>
    import {onMount} from "svelte";
    import Chart from "chart.js/auto"
    import ChartDataLabels from 'chartjs-plugin-datalabels';
    export let burnData;
    let ctx;
    let myChart;

    Chart.register(ChartDataLabels)

    $: if (myChart){
        myChart.data.datasets[0].data = burnData
        myChart.update()
    }
    onMount(async () => {
        myChart = new Chart(ctx, {
            type: "bar",
            data: {
                labels: ['Tungsten', 'BoxHead', 'DaftPunk', 'Murica', 'GoldenBoneDaddy'],
                datasets: [
                    {
                        label: 'Tokens Burned',
                        data: burnData,
                        backgroundColor: [
                            "rgba(189,186,186,0.2)",
                            "rgba(82,57,59,0.4)",
                            "rgba(75, 192, 192, 0.2)",
                            "rgba(168,72,91,0.55)",
                            "rgba(255, 206, 86, 0.2)",
                        ],
                        borderColor: [
                            "rgb(246,246,246)",
                            "rgb(117,95,102)",
                            "rgba(75, 192, 192, 1)",
                            "rgb(239,119,119)",
                            "rgba(255, 206, 86, 1)",
                        ],
                        borderWidth: 1,
                    },
                ],
            },
            options: {
                plugins: {
                    datalabels: {
                        anchor: 'end',
                        align: 'top',
                        formatter: Math.round,
                        font: {
                            weight: 'bold',
                            size: 16
                        }
                    },
                    legend: {
                        display: false
                    }
                }
            }
        });
    });
</script>

<canvas id="myChart" bind:this={ctx} />
